import AlertModal from 'components/common/AlertModal';
import ConfirmModal from 'components/common/ConfirmModal';
import useGlobalModal from 'components/common/GlobalModal/useGlobalModal';
import { DisplayControlGroup } from 'features/DisplayControlGroup/models';
import DetailModal from 'features/DisplayControlGroup/pages/Detail';
import { useEffect, useRef, useState } from 'react';
import { Button, Col, Form, Row, Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import ControlGroupModal from '../../ControlGroup';
import service from '../services';

// define props
interface DataTableProps {
  dataTable: DisplayControlGroup[];
  setDataTable: (dataTable: DisplayControlGroup[]) => void;
}

function TableList({ dataTable, setDataTable }: DataTableProps) {
  const { t } = useTranslation();
  const initialState = (Array.isArray(dataTable) ? dataTable : []).reduce((o, key) => ({ ...o, [key.id]: false }), {});
  const [checked, setChecked] = useState<any>(initialState);
  const refBtnDetail = useRef<HTMLButtonElement>(null);
  const refBtnDelete = useRef<HTMLButtonElement>(null);
  const [showDetailModal, setshowDetailModal] = useState(false);
  const [showControlGroupModal, setshowControlGroupModal] = useState(false);
  const [idDetail, setIdDetail] = useState<string>('');
  const [isAdd, setIsAdd] = useState<boolean>(false);
  const { showGlobalModal, closeGlobalModal } = useGlobalModal();

  // handle unchecked all state changes
  function handleUncheckedAll() {
    const newState = dataTable.reduce((o, key) => ({ ...o, [key.id]: false }), {});
    setChecked(newState);
  }

  // toggle checkbox
  function toggleCheck(value: number) {
    let newState = { ...checked };
    newState[value] = !newState[value];
    setChecked(newState);
  }

  // handle reload
  async function handleReload() {
    await service.get().then((result) => {
      setDataTable(result.data);
    });
    handleUncheckedAll();
  }

  // useEffects check change checked
  useEffect(() => {
    // handle disabled btn view detail
    function handleDisableBtnDelte() {
      let count = Object.keys(checked).filter((key) => checked[key] === true).length;
      if (count > 0) {
        return false;
      }
      return true;
    }

    // handle disabled btn view detail
    function handleDisableBtnViewDetail() {
      let count = Object.keys(checked).filter((key) => checked[key] === true).length;
      if (count > 1 || count === 0) {
        return true;
      }
      return false;
    }

    if (handleDisableBtnViewDetail()) {
      if (refBtnDetail.current) refBtnDetail.current.disabled = true;
    } else {
      if (refBtnDetail.current) refBtnDetail.current.disabled = false;
    }
    if (handleDisableBtnDelte()) {
      if (refBtnDelete.current) refBtnDelete.current.disabled = true;
    } else {
      if (refBtnDelete.current) refBtnDelete.current.disabled = false;
    }

    let ids = Object.keys(checked).filter((key) => checked[key] === true);
    setIdDetail(ids[0]);
  }, [checked]);

  // handle function go to default page
  function handleShowEditModel() {
    setshowDetailModal(true);
    setIsAdd(false);
  }

  function handleshowControlGroupModalForm() {
    setshowControlGroupModal(true);
  }

  // handle function go to add page
  function handleShowAddModel() {
    setshowDetailModal(true);
    setIsAdd(true);
  }

  function handleDelete() {
    showGlobalModal(() => (
      <ConfirmModal
        title={t('App.confirm')}
        message={t('DisplayControlGroup.Confirm.Delete_Control_Group')}
        onConfirm={processCheckConfirmDelete}
      />
    ));
  }

  // delete muilti record
  async function processCheckConfirmDelete() {
    let idsArr = Object.keys(checked).filter((key) => {
      if (checked[key] === true) {
        return parseInt(key);
      }
      return null;
    });
    let ids = idsArr
      .map((value) => {
        return parseInt(value);
      })
      .join(',');

    await service
      .checkDelete(ids)
      .then((result) => {
        processDelete(ids, []);
      })
      .catch((err: any) => {
        const message = err.response.data.message;
        let msg = t('DisplayControlGroup.Confirm.Delete_Control_Group_Already_Exit', { message });
        showGlobalModal &&
          showGlobalModal(() => (
            <ConfirmModal
              title={t('App.confirm')}
              message={msg}
              onConfirm={() => closeGlobalModal && closeGlobalModal()}
            ></ConfirmModal>
          ));
      });
  }

  async function processDelete(ids: string, idsExact: []) {
    await service
      .delete(ids, idsExact)
      .then(async () => {
        showGlobalModal &&
          showGlobalModal(() => (
            <AlertModal
              onClose={handleReload}
              title={t('DisplayControlGroup.Validator.success')}
              message={t('DisplayControlGroup.Validator.delete_success')}
            ></AlertModal>
          ));
      })
      .catch((err: any) => {
        const message = err.response.data.data.error;
        showGlobalModal &&
          showGlobalModal(() => (
            <AlertModal
              onClose={handleReload}
              title={t('DisplayControlGroup.Validator.error')}
              message={message}
            ></AlertModal>
          ));
      });
  }

  // close modal edit
  function handleCloseModalEdit() {
    setshowDetailModal(false);
    handleUncheckedAll();
  }

  async function handleRestore(id: number) {
    await service
      .restore(id)
      .then(async () => {
        showGlobalModal &&
          showGlobalModal(() => (
            <AlertModal
              onClose={handleReload}
              title={t('DisplayControlGroup.Validator.success')}
              message={t('DisplayControlGroup.Validator.restore_success')}
            ></AlertModal>
          ));
      })
      .catch((err: any) => {
        <AlertModal
          title={t('DisplayControlGroup.Validator.error')}
          message={t('DisplayControlGroup.Validator.500')}
        ></AlertModal>;
      });
  }

  return (
    <>
      <Row className="mb-2">
        <Col sm={2} lg={2}></Col>
        <Col sm={10} lg={10} className="d-flex justify-content-end">
          <button ref={refBtnDetail} type="button" className="btn btn-primary" onClick={handleShowEditModel}>
            {t('DisplayControlGroup.Button.detail')}
          </button>
          {showDetailModal && (
            <DetailModal
              id={idDetail}
              show={showDetailModal}
              handleCloseModalEdit={handleCloseModalEdit}
              dataTable={dataTable}
              setDataTable={setDataTable}
              isAdd={isAdd}
              showGlobalModal={showGlobalModal}
            />
          )}
          <span className="ps-2 pe-2"></span>
          <button type="button" ref={refBtnDelete} className="btn btn--red" onClick={handleDelete}>
            {t('DisplayControlGroup.Button.delete')}
          </button>
          <span className="ps-2 pe-2"></span>
          <button type="button" className="btn btn--dark-green" onClick={handleShowAddModel}>
            {t('DisplayControlGroup.Button.add_new')}
          </button>
        </Col>
      </Row>
      <div className="sticky-table flex-grow-1 flex-shrink-1 m-1 mr-1">
        <Table>
          <thead className="text-center" style={{ backgroundColor: '#36489a', color: '#fff' }}>
            <tr>
              <th rowSpan={2} className="align-top" style={{ width: '5%' }}>
                {t('DisplayControlGroup.Table.selection')}
              </th>
              <th rowSpan={1} className="align-top" style={{ width: '30%' }}>
                {t('DisplayControlGroup.Table.code')}
              </th>
              <th rowSpan={1} className="align-top" style={{ width: '30%' }}>
                {t('DisplayControlGroup.Table.name')}
              </th>
              <th rowSpan={2} className="align-top">
                {t('DisplayControlGroup.Table.note')}
              </th>
              <th>{t('DisplayControlGroup.Table.action')}</th>
            </tr>
          </thead>
          <tbody className="text-center">
            {dataTable &&
              dataTable.map((value: DisplayControlGroup) => (
                <tr key={value.id} className={value.delete_flg ? 'deleted_row ' : ''}>
                  <td>
                    {!value.delete_flg ? (
                      <Form.Check
                        type="checkbox"
                        value={value.id}
                        checked={checked[value.id] || false}
                        disabled={value.delete_flg}
                        onChange={() => toggleCheck(value.id)}
                        style={{ fontSize: '1.5rem' }}
                      ></Form.Check>
                    ) : (
                      <Button
                        className="btn--orange"
                        onClick={() => {
                          handleRestore(value.id);
                        }}
                      >
                        {t('DisplayControlGroup.Button.restore')}
                      </Button>
                    )}
                  </td>
                  <td>{value.code}</td>
                  <td>{value.name}</td>
                  <td title={value.note}>
                    <span className="ms-1">
                      {value.note.slice(0, 15)} {value.note && '...'}
                    </span>
                  </td>
                  <td>
                    <Button
                      variant="primary"
                      onClick={() => {
                        handleshowControlGroupModalForm();
                        setIdDetail(value.id.toString());
                      }}
                    >
                      <span
                        dangerouslySetInnerHTML={{ __html: t('DisplayControlGroup.Button.display_control_group') }}
                      ></span>
                    </Button>
                  </td>
                </tr>
              ))}
          </tbody>
        </Table>
      </div>

      {showControlGroupModal && (
        <ControlGroupModal
          id={parseInt(idDetail)}
          isVisible={showControlGroupModal}
          onClose={() => setshowControlGroupModal(false)}
        />
      )}
    </>
  );
}

export default TableList;
